import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import CategoryNav from '../shop/CategoryNav';
import Footer from './Footer';
import BackToTop from './BackToTop';
import WhatsAppButton from './WhatsAppButton';
import { usePageVisibility } from '../../context/PageVisibilityContext';

const PublicLayout = () => {
  const { isPageActive } = usePageVisibility();
  return (
    <section className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
      <CategoryNav />
      <main className="flex-1">
        <Outlet />
      </main>
      {isPageActive('footer') && <Footer />}
      <BackToTop />
      <WhatsAppButton />
    </section>
  );
};

export default PublicLayout;
